import { ApolloLink } from '@apollo/client';

import { getEnabledFeaturesAndVariables } from './';

/**
 * Apollo link that adds a X-Features header to the request that is a
 * serialized JSON string of enabled features and their vars (if applicable).
 * Any previously existing value of these headers will be overwritten.
 */
export const featuresLink = new ApolloLink((operation, forward) => {
  const { headers } = operation.getContext();
  operation.setContext({
    headers: {
      ...headers,
      'X-WB-Features': JSON.stringify(getEnabledFeaturesAndVariables()),
    },
  });
  // Call the next link in the middleware chain.
  return forward(operation);
});
